import { createGlobalStyle, css } from 'styled-components'
import { hpxTokens } from '../LayoutTheme/hpxTokens'

export const HpxGlobalStyleOverride = createGlobalStyle`
  && {
    ${({ theme: { isHpx } }) =>
      isHpx &&
      css`
        body {
          .instant-ink-enroll-hpx-button-override {
            &[disabled] {
              color: #ffffff;
            }
          }
          .instant-ink-enroll-hpx-button-override-checkout {
            &[disabled] {
              background-color: #edeefe;
            }
          }
          .instant-ink-enroll-hpx-secondary-button-override {
            &:not([disabled]) {
              color: ${hpxTokens.secondaryText};
              border-color: ${hpxTokens.secondaryBorder};

              &:hover {
                color: ${hpxTokens.secondaryText};
                border-color: ${hpxTokens.secondaryBorder};
              }

              &:active {
                background-color: ${hpxTokens.royalBlue3};
              }
            }
          }

          [data-testid='validations-modal'] button {
            &:not([disabled]) {
              color: ${hpxTokens.secondaryText};
              border-color: ${hpxTokens.secondaryBorder};

              &:hover {
                color: ${hpxTokens.secondaryText};
                border-color: ${hpxTokens.secondaryBorder};
              }

              &:active {
                background-color: ${hpxTokens.royalBlue3};
              }
            }
          }

          [data-testid='shipping-form'],
          [data-testid='ftm-shipping-step'] {
            input:focus,
            textarea:focus,
            [class*='InputField']:focus,
            [class*='FormControl']:focus-within {
              border-color: ${hpxTokens.royalBlue7} !important;
            }

            [class*='InputField']:focus-within,
            [class*='FormControl']:focus-within {
              border-color: ${hpxTokens.royalBlue7} !important;
            }
          }
        }
      `}
  }
`
